import { useAuthorization } from '../../../authorization/useAuthorization';
import { ConstantActions } from '../../../Services/_actions/index.js';
import { ACCESS } from '../../../constants/authz/accessPresets.constants';
import { TEMPLATE_PERMISSIONS } from '../constants/templatePermissions';

/**
 * WhatsApp template permissions — RBAC v2 object/feature grants with legacy fallback.
 */
export default function useTemplatePermissions() {
  const { can, isAuthzV2Enabled } = useAuthorization();
  const constActions = ConstantActions();

  if (isAuthzV2Enabled) {
    return {
      canView: can(ACCESS.WHATSAPP_TEMPLATES_VIEW),
      canCreate: can(ACCESS.MESSAGE_TEMPLATE_CREATE),
      canEdit: can(ACCESS.MESSAGE_TEMPLATE_UPDATE),
      canDelete: can(ACCESS.MESSAGE_TEMPLATE_DELETE),
      canSend: can(ACCESS.WHATSAPP_TEMPLATE_SEND),
      canViewPerformance: can(ACCESS.WHATSAPP_TEMPLATE_PERFORMANCE),
      canViewOptin: can(ACCESS.WHATSAPP_OPTIN),
    };
  }

  return {
    canView: constActions.userHasPermission([TEMPLATE_PERMISSIONS.pageAccess]),
    canCreate: constActions.userHasPermission([TEMPLATE_PERMISSIONS.addTemplates]),
    canEdit: constActions.userHasPermission([TEMPLATE_PERMISSIONS.editTemplates]),
    canDelete: constActions.userHasPermission([TEMPLATE_PERMISSIONS.deleteTemplates]),
    canSend: constActions.userHasPermission([TEMPLATE_PERMISSIONS.pageAccess]),
    canViewPerformance: constActions.userHasPermission([TEMPLATE_PERMISSIONS.pageAccess]),
    canViewOptin: constActions.userHasPermission([TEMPLATE_PERMISSIONS.optinUsers]),
  };
}
